import units from "utils/units"
import { BaseElement } from "utils/base-element"
import { parseFloat } from "utils/helpers"

import "./index.scss"

function kind(value: number) {
  if (value > 1) return "a2"
  if (value > 0.5) return "a1"
  if (value > -0.5) return "0"
  if (value > -1) return "b1"
  return "b2"
}

export class TempDiff extends BaseElement {
  value?: number
  precision: number
  degrees: boolean
  sign: boolean

  constructor() {
    super()
    this.value = parseFloat(this.getAttribute("value"))
    this.precision = parseInt(this.getAttribute("precision") ?? "1", 10)
    this.degrees = this.getAttribute("degrees") !== null
    this.sign = this.getAttribute("sign") !== null
    units.onChange(() => this.update())
  }

  connectedCallback() {
    this.addClassName()
    this.update()
  }

  update() {
    if (this.value === undefined) {
      this.textContent = "—"
    } else {
      this.classList.toggle(this.modClassName(kind(this.value)), true)

      let text = units.formatTempDiff(this.value, {
        withUnits: false,
        precision: this.precision,
        sign: this.sign,
      })
      if (this.degrees) text += "°"
      this.textContent = text
    }
  }
}

BaseElement.define("temp-diff", TempDiff)
